import posthog from 'posthog-js'
import LogRocket from 'logrocket'

export const analytics = {
  init() {
    if (import.meta.env.VITE_POSTHOG_KEY) {
      posthog.init(import.meta.env.VITE_POSTHOG_KEY as string, {
        api_host: 'https://hog.dacr.com',
        person_profiles: 'always',
      })
    }

    if (import.meta.env.VITE_LOGROCKET_ID) {
      LogRocket.init(import.meta.env.VITE_LOGROCKET_ID)
    }
  },

  identify(userId: string, traits?: Record<string, string | number | boolean>) {
    posthog.identify(userId, traits)
    LogRocket.identify(userId, traits)
  },

  track(event: string, properties?: Record<string, string | number | boolean>) {
    posthog.capture(event, properties)
    LogRocket.track(event, properties)
  },

  page(name: string) {
    posthog.capture('$pageview', { page: name })
  },

  captureException(
    error: Error,
    context?: Record<string, string | number | boolean>
  ) {
    LogRocket.captureException(error, { extra: context })
  },

  captureGraphQLError(operationName: string, errors: readonly unknown[]) {
    LogRocket.captureException(new Error(`GraphQL: ${operationName}`), {
      extra: { errors: JSON.stringify(errors) },
    })
  },

  reset() {
    posthog.reset()
    LogRocket.startNewSession()
  },
}
